import {RangeModel} from '../shared/range.model';
import {Enums} from '../../extensions/enums';
import {QuestionExtendedModel} from '../question-extended.model';

export class SingleSubtractionNeededAmountModel extends QuestionExtendedModel {

  model = {
    firstRange: new RangeModel(),
    total: new RangeModel(),
    possibleAnswers: new RangeModel(),
    minOutcome: null,
    maxOutcome: null,
    numAnswers: 4,
    imageTypeOne: Enums.QuestionImages.Apple
  };

  static generateModel(json: any): SingleSubtractionNeededAmountModel {

    const q = new SingleSubtractionNeededAmountModel();

    const model = json.model;

    if (model) {

      if (model.firstRange) {
        q.model.firstRange = RangeModel.generateModel(model.firstRange);
      }

      if (model.total) {
        q.model.total = RangeModel.generateModel(model.total);
      }

      if (model.possibleAnswers) {
        q.model.possibleAnswers = RangeModel.generateModel(model.possibleAnswers);
      }

      q.model.minOutcome = model.minOutcome;
      q.model.maxOutcome = model.maxOutcome;
      q.model.numAnswers = model.numAnswers;
      q.model.imageTypeOne = model.imageTypeOne;

    }

    return q;

  }

}
